module.exports = __webpack_public_path__ + "static/media/upload-audio.0a33e961.svg";